module.exports = __webpack_public_path__ + "media/images/flags/1x1/blr-89561bc1f83889d7a564809981cfd96b.svg";